import React from "react";
import * as XLSX from "xlsx";
import ImportadorExcelGenerico from "../../../../../Components/ImportadorExcelGenerico";

const columnasPreview = [
  {
    title: "Nombre",
    dataIndex: "nombre",
    key: "nombre",
    width: 280,
  },
];

/**
 * Genera la plantilla `plantillaNivelesEducativos.xlsx`:
 *   - Hoja 1 "Niveles Educativos" con columna "Nombre" y dos filas de ejemplo.
 *   - Hoja 2 "Existentes" con los niveles ya registrados en la empresa,
 *     para que el usuario sepa qué evitar duplicar.
 */
const construirPlantilla = (catalogos) => {
  const wb = XLSX.utils.book_new();

  const ejemplos = [
    { Nombre: "Primaria" },
    { Nombre: "Secundaria" },
  ];
  const hojaPrincipal = XLSX.utils.json_to_sheet(ejemplos, {
    header: ["Nombre"],
  });
  hojaPrincipal["!cols"] = [{ wch: 32 }];
  XLSX.utils.book_append_sheet(wb, hojaPrincipal, "Niveles Educativos");

  const existentes = (catalogos.niveles || []).map((n) => ({
    Nombre: n.nombre,
    Estado: n.estado === 1 ? "Activo" : "Deshabilitado",
  }));
  const hojaExistentes =
    existentes.length > 0
      ? XLSX.utils.json_to_sheet(existentes)
      : XLSX.utils.json_to_sheet([{ Nombre: "(no hay niveles registrados)" }]);
  hojaExistentes["!cols"] = [{ wch: 32 }, { wch: 16 }];
  XLSX.utils.book_append_sheet(wb, hojaExistentes, "Existentes");

  return wb;
};

/**
 * Valida cada fila del Excel.
 *   - Nombre: requerido, string no vacío, no debe duplicarse contra los
 *     existentes ni contra otras filas del mismo archivo.
 */
const validarFila = (fila, catalogos, _indice, contexto) => {
  const errores = [];
  const nombre = fila["Nombre"] ? String(fila["Nombre"]).trim() : "";

  if (!nombre) {
    errores.push({ campo: "Nombre", motivo: "está vacío" });
    return { ok: false, errores };
  }

  const llave = nombre.toLowerCase();

  const existeYa = (catalogos.niveles || []).some(
    (n) => (n.nombre || "").trim().toLowerCase() === llave,
  );
  if (existeYa) {
    errores.push({
      campo: "Nombre",
      motivo: "ya existe un nivel educativo con ese nombre",
    });
  }

  if (contexto.clavesYaUsadas.has(llave)) {
    errores.push({
      campo: "Nombre",
      motivo: `nombre repetido en el archivo (también está en la fila ${contexto.clavesYaUsadas.get(llave)})`,
    });
  } else {
    contexto.clavesYaUsadas.set(llave, (fila["__rowNum__"] ?? 0) + 1);
  }

  if (errores.length > 0) {
    return { ok: false, errores };
  }

  return {
    ok: true,
    datos: { nombre },
  };
};

const ImportarNivelesEducativos = (props) => (
  <ImportadorExcelGenerico
    {...props}
    titulo="Importar Niveles Educativos"
    nombreEntidadPlural="niveles educativos"
    endpointDatosImportar="nivelesEducativos/datosParaImportarNivelesEducativos"
    endpointImportar="nivelesEducativos/importarNivelesEducativos"
    nombrePlantilla="plantillaNivelesEducativos.xlsx"
    construirPlantilla={construirPlantilla}
    validarFila={validarFila}
    columnasPreview={columnasPreview}
  />
);

export default ImportarNivelesEducativos;
